// extracted by mini-css-extract-plugin
export default {"stepContainer":"ReciepeManagement_stepContainer__P1fXw","compMainCont":"ReciepeManagement_compMainCont__mFGxJ"};